import { Flex, HStack, VStack, Box, Button, Spinner, Text } from '@cad-arc';
import { useAttributeOptionsByType } from '../attributes/use-attribute-options-by-type';
import { CheckboxMultiselect } from '../common/components/checkbox-multiselect';

export function CategoryFilterPopover(props: {
    selectedFilters: number[];
    setSelectedFilters: React.Dispatch<number[]>;
}): React.ReactElement {
    const { attributeOptions, isInitialLoading } = useAttributeOptionsByType({
        attributeType: 'ROLODEX_PROFILE_TYPE',
        params: {
            include_disabled: false,
            include_is_none: false,
        },
    });
    if (isInitialLoading) {
        return (
            <Flex h="100%" w="100%" justifyContent="center" alignItems="center">
                <Spinner />
            </Flex>
        );
    }
    return (
        <Box maxHeight="450px" overflowY="auto" textTransform="none" overflow="visible">
            <VStack overflow="visible">
                <HStack w="100%" justifyContent="space-between" overflow="visible">
                    <Text>Category</Text>
                    <HStack>
                        {props.selectedFilters.length > 0 ? (
                            <Button
                                isLoading={isInitialLoading}
                                variant="ghost"
                                onClick={() => {
                                    props.setSelectedFilters([]);
                                }}
                            >
                                Clear All
                            </Button>
                        ) : undefined}
                        {props.selectedFilters.length !== attributeOptions.length ? (
                            <Button
                                isLoading={isInitialLoading}
                                variant="ghost"
                                onClick={() => {
                                    props.setSelectedFilters(
                                        attributeOptions.map(
                                            (attributeOption) => attributeOption.value
                                        )
                                    );
                                }}
                            >
                                Select All
                            </Button>
                        ) : undefined}
                    </HStack>
                </HStack>
                <Box maxHeight="255px" overflowY="auto">
                    <CheckboxMultiselect
                        options={attributeOptions}
                        value={props.selectedFilters}
                        onChange={(value) => {
                            props.setSelectedFilters(value as number[]);
                        }}
                    />
                </Box>
            </VStack>
        </Box>
    );
}
